const ROUTES_PATH = {
  DEFAULT: "/",
  HOME: "/home",
  SYSTEMS: "/systems/:systemId/",
  SETTINGS: "/settings/",
  UNUTHORIZED: "/unauthorized",
  LOGOUT: "/logout",
  WILDCARD: "*"
};

export const PAGES_KEYS = {
  DASHBOARDS: "DASHBOARDS",
  CHARTS: "CHARTS",
  REPORTS: "REPORTS",
  ANALYTICS: "ANALYTICS",
  INSIGHTS: "INSIGHTS",
  ALARMS: "ALARMS",
  TAGS: "TAGS",
  REPORTS_HISTORY: "REPORTS_HISTORY",
  BASELINES: "BASELINES",
  ACCOUNT: "ACCOUNT",
  NOTIFICATION: "NOTIFICATION",
  USERS: "USERS",
  SYSTEMS: "SYSTEMS",
  USERGUIDE: "USERGUIDE",
  LOGOUT: "LOGOUT"
};

export const SYSTEMS_PAGES = {
  DASHBOARDS: "dashboards",
  CHARTS: "charts",
  REPORTS: "reports",
  ANALYTICS: "analytics",
  INSIGHTS: "smartinsight",
  ALARMS: "alarms",
  TAGS: "tags",
  REPORTS_HISTORY: "reports/history",
  BASELINES: "baselines"
};

export const SETTINGS_PAGES = {
  ACCOUNT: "account",
  NOTIFICATION: "notifications",
  USERS: "users",
  SYSTEMS: "systems",
  USERGUIDE: "userguide",
  LOGOUT: "logout"
};

export default ROUTES_PATH;
